import type { MagazineArticle } from '../helpers/magazineCategory';
import { MagazineArticlesFeed } from '../MagazineArticlesFeed/MagazineArticlesFeed';
import { MagazineTrackMeta } from '../MagazineBody/MagazineTrackMeta';
import { MagazineCategoryHeader } from '../MagazineCategoryHeader/MagazineCategoryHeader';

type MagazineCategoryPageProps = {
  categorySlug: string;
  categoryName: string;
  pageNumber?: number;
  articles: readonly MagazineArticle[];
  totalPages: number;
  baseImgUrl: string;
};

function MagazineCategoryPage({ categorySlug, categoryName, pageNumber, articles, totalPages, baseImgUrl }: MagazineCategoryPageProps) {
  const currentPage = pageNumber ?? 1;

  return (
    <div className="flex flex-col gap-8" data-testid="magazine-category-page">
      <MagazineTrackMeta container="Category" type={categoryName} />
      <MagazineCategoryHeader categoryName={categoryName} />
      <MagazineArticlesFeed
        articles={articles}
        currentPage={currentPage}
        totalPages={totalPages}
        baseImgUrl={baseImgUrl}
        hrefContext={{ type: 'category', categorySlug }}
        priorityFirstCard={currentPage === 1}
      />
    </div>
  );
}

export { MagazineCategoryPage, type MagazineCategoryPageProps };
